<template>
  <div class="loading-overlay">
    <div class="loading dsize"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  @extend %flex-allcenter;
  background: $white;
  z-index: map-get($z-index, embpreloader);
  overflow: hidden;
  .loading {
    --dsize: 35px;
    --progress-color: #888;
    border: 6px solid #ccc;
    border-right-color: #888;
    animation: rotate 1s infinite linear;
  }
}

@keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
